import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setModalType } from '../../../../store/modal/actions';
import { ModalType } from '../../../../store/modal/types';
import { closeViewer } from '../../../../store/viewer/actions';
import { captureButtonPress } from '../../../../features/analytics';
import { ROUTES } from '../../../../Routes/routes';
import { selectVariant } from '../../../../store/googleOptimize/selectors';
import { env } from '../../../config/env';
// import { VRCanvas } from '@react-three/xr';
// import { Canvas } from '@react-three/fiber';
import { getRedirectionURLOnTourExit } from '../../../../utils/getRedirectionURLOnTourExit';
import { TourExitConfirmationPopupView } from './TourExitConfirmationPopupView';

interface Props {
  tourID: string;
  viewpointID: string;
  isTrialTour: boolean;
}

// Confirmation when trying to exit a tour
const TourExitConfirmationPopup = ({
  tourID,
  viewpointID,
  isTrialTour,
}: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const variant = useSelector(selectVariant(env.GO_EXP_ID_FOR_LIBRARY_PAGE));
  // const VRIsSupported = navigator?.userAgent?.includes('OculusBrowser');

  const handleConfirm = () => {
    captureButtonPress({
      page: window.location.pathname,
      buttonName: 'Tour Close Confirmed',
      tourID,
      viewpointID,
    });

    const externalURL = getRedirectionURLOnTourExit(env.APP_ENV);

    if (externalURL) {
      window.location.href = externalURL;

      return;
    } else if (!isTrialTour) {
      history.push(ROUTES.myTrips);
    } else if (variant === '0' && !env.IS_AO) {
      history.push(ROUTES.library);
    } else if (variant === '1' && !env.IS_AO) {
      history.push({ pathname: ROUTES.index, hash: '#tours_section' });
    } else {
      // fallback to home page
      history.push(ROUTES.index);
    }
    dispatch(closeViewer());

    dispatch(setModalType({ modalType: ModalType.NONE, modalData: null }));
    // VRIsSupported && history.go(0);
  };

  const handleCancel = () => {
    captureButtonPress({
      page: window.location.pathname,
      buttonName: 'Tour Close Cancelled',
      tourID,
      viewpointID,
    });

    dispatch(setModalType({ modalType: ModalType.NONE, modalData: null }));
  };

  return (
    <TourExitConfirmationPopupView
      handleCancel={handleCancel}
      handleConfirm={handleConfirm}
    />
  );
};

export default TourExitConfirmationPopup;
